/* @flow */
import {Observable} from 'rxjs/Observable';
import type {ActionsObservable} from 'redux-observable';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/merge';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';

import {fetchList} from 'nutshell-core/entities/fetch-list';
import {safelyParseError} from 'nutshell-core/utils';

import {
    updateCustomSegmentListData,
    failCustomSegmentListData,
    type CustomSegmentListRequestedAction,
} from './custom-segment-actions';

export const requestCustomSegmentListEpic = (action$: ActionsObservable<*>) =>
    action$
        .ofType('CUSTOM_SEGMENT_LIST_DATA_REQUESTED')
        .switchMap((action: CustomSegmentListRequestedAction) => {
            const {filters, pageNum = 1, columns, sort, q} = action.payload;

            // Our pagination components aren't 0-based, but this specific
            // request expects page 0 to be the first page. Using Math.max() here
            // in case older URLs with page 0 are still in the wild
            const adjustedPageNum = Math.max(0, pageNum - 1);

            const listRequestStream = Observable.fromPromise(
                fetchList('contacts', {
                    filter: filters,
                    sort,
                    page: {page: adjustedPageNum},
                    fields: columns,
                    q,
                })
            );

            const editionPeopleListDataStream = listRequestStream.map((response) =>
                updateCustomSegmentListData(response)
            );

            return editionPeopleListDataStream.catch((err) => {
                const safeError = safelyParseError(err);

                return Observable.of(failCustomSegmentListData(safeError));
            });
        });
